<template>
  <div class="macket-al">
    <div class="macket">
      <h3>万亿级县域餐饮供应链市场</h3>

      <div class="honor-line-wrapper">
        <div class="honor-line"></div>
      </div>

      <ul class="macket-list">
        <li class="cfileli">
          <div class="img-view">
            <img src="../../../assets/images/new-img/company/1.jpg">
          </div>
          <div>
            <div class="cfile-title">巨大稳定的市场空间</div>
            <div class="cfile-content">近2000个县域，4.86-5.47万亿的食材消费规模</div>
          </div>
        </li>
        <li class="cfileli">
          <div class="img-view">
            <img src="../../../assets/images/new-img/company/2.jpg">
          </div>

          <div>
            <div class="cfile-title">市场的成熟</div>
            <div class="cfile-content">用户的互联网思维意识已经形成</div>
          </div>
        </li>
        <li class="cfileli">
          <div class="img-view">
            <img src="../../../assets/images/new-img/company/3.jpg">
          </div>
          <div>
            <div class="cfile-title">市场的需求</div>
            <div class="cfile-content">一站式采购已经成为必选之路</div>
          </div>
        </li>
        <li class="cfileli">
          <div class="img-view">
            <img src="../../../assets/images/new-img/company/4.jpg">
          </div>
          <div>
            <div class="cfile-title">市场机会</div>
            <div class="cfile-content">信息闭塞、商品流通效率低，一家独大商户缺乏选择空间</div>
          </div>
        </li>
        <li class="cfileli">
         <div class="img-view">
            <img src="../../../assets/images/new-img/company/5.jpg">
         </div>
          <div>
            <div class="cfile-title">全国供应链的布局</div>
            <div class="cfile-content">美菜将于县域建立一个互为供应商的完整生态体系打通农产品上下行的通道</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "countyProfile",
  data() {
    return {
      dialogVisbility: false
    };
  }
};
</script>

<style lang="scss" scoped>
.macket {
  width: 1185px;
  margin: 0 auto;
}
.macket-al {
  padding: 50px 0;
  width: 100%;
  display: inline-block;
  background: #f8f8f8;
  h3 {
    text-align: center;
    font-size: 30px;
    font-weight: 600;
  }
  .honor-line-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .honor-line {
    height: 4px;
    width: 80px;
    background: #67b765;
    margin-top: 45px;
  }
}
.macket-list {
  display: flex;
  justify-content: space-between;
  padding-top: 26px;
  width: 100%;

  .cfileli {
    width: 25%;
    margin: 0 10px !important;
    background: white;
    .img-view {
      width: 100%;
      height: 120px;
      overflow: hidden;
      margin: 0 auto;


      img {
        width: 100%;
      }
    }
    .cfile-title {
      font-size: 18px;
      color: #333333;
      text-align: center;
      margin-top: 30px;
      font-weight: 600;
    }
    .cfile-content {
      margin-top: 20px;
      margin-bottom: 20px;
      padding: 0 30px;
      font-size: 14px;
      text-align: center;
      line-height: 21px;
    }
  }
  li {
    flex: 1;
    &:hover {
      box-shadow: 0 6px 13px 0 rgba(200, 195, 195, 0.5);
    }
  }
}
</style>
